import { useQuery } from '@tanstack/react-query';

import { pinsFromFlows, type IPin } from '../../entities/transform';
import {
  getLibraryItem,
  getLibraryVersion,
  libraryKeys,
  listLibraryVersions,
} from '../../entities/library';

export const useLibraryItem = (itemId: string) => {
  const item = useQuery({
    queryKey: libraryKeys.item(itemId),
    queryFn: () => getLibraryItem(itemId),
  });
  const versions = useQuery({
    queryKey: libraryKeys.versions(itemId),
    queryFn: () => listLibraryVersions(itemId),
  });
  const pins: IPin[] = pinsFromFlows(item.data?.flows ?? []);

  return { item, versions, pins };
};

export const useVersionBody = (itemId: string, version: number | null) =>
  useQuery({
    queryKey: libraryKeys.version(itemId, version),
    queryFn: () => getLibraryVersion(itemId, version ?? 0),
    enabled: version !== null && version > 0,
  });
